module.exports = __webpack_public_path__ + "files/71bb3bf8d629216c746da29c9c5c0110.png";